document.addEventListener('DOMContentLoaded', function() {
  console.log("Slideshow script running");

  var lpsBannerSections = document.querySelectorAll('[class^="lps-banner-section-"]');

  lpsBannerSections.forEach(function(section) {
    var intervalTime = parseInt(section.getAttribute('data-interval')) || 5000;
    var slides = section.querySelectorAll('.slide');
    var dots = section.querySelectorAll('.dot');
    var slideIndex = 0;
    var slideInterval;

    if (slides.length === 0) {
      console.log("No slides found");
      return;
    }

    // Function to show a specific slide and activate the corresponding dot
    function showSlide(n) {
      slideIndex = (n + slides.length) % slides.length; // Ensure the index wraps around correctly

      // Hide all slides and deactivate all dots
      slides.forEach(function(slide, index) {
        slide.style.display = (index === slideIndex) ? 'block' : 'none';
      });

      dots.forEach(function(dot, index) {
        dot.classList.toggle('active', index === slideIndex);
      });
    }

    // Function to move to the next slide
    function nextSlide() {
      showSlide(slideIndex + 1);
    }

    // Initialize the slideshow by showing the first slide
    showSlide(slideIndex);

    // Start the automatic slideshow
    slideInterval = setInterval(nextSlide, intervalTime);

    // Add click event listeners to dots for manual navigation
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        clearInterval(slideInterval); // Stop the slideshow when a dot is clicked
        showSlide(index); // Show the clicked slide
        slideIndex = index; // Update the current index
        slideInterval = setInterval(nextSlide, intervalTime); // Restart the slideshow
      });
    });

    // Pause the slideshow when hovering over the section
    section.addEventListener('mouseenter', function() {
      clearInterval(slideInterval);
    });

    // Resume the slideshow when no longer hovering
    section.addEventListener('mouseleave', function() {
      slideInterval = setInterval(nextSlide, intervalTime);
    });
  });
});